

import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { FaEdit, FaTrash } from 'react-icons/fa';
import Select from "react-select";
import config from "../../../config/config";
import { getAuthToken } from "../../../utils/token";
import Loader from '../../loader/Loader';
import axios from "axios";
const customStyles = {
  headCells: {
    style: {
      backgroundColor: '#0d6efd',
      color: 'white',
      fontWeight: 'bold',
      fontSize: '14px',
    },
  },
};
const typeOptions = [
  { value: "Degeaser", label: "Degeaser" },
  { value: "Grit blasting type 1", label: "Grit blasting type 1" },
  { value: "Grit blasting type 2", label: "Grit blasting type 2" },
  { value: "Adhesive application type 1", label: "Adhesive application type 1" },
  { value: "Adhesive application type 2", label: "Adhesive application type 2" },
  { value: "Adhesive application manual", label: "Adhesive application manual" },
  { value: "Injection molding type 1", label: "Injection molding type 1" },
  { value: "Injection molding type 2", label: "Injection molding type 2" },
  { value: "Painting", label: "Painting" },
];

export default function MachineTable() {
  const [machines, setMachines] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [listLoading, setListLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);

  const initialMachineState = {
    name: '',
    type: '',
    capacity: '',
    line: '',
    department: '',
    last_maintenance_at: '',
    next_maintenance_due: '',
    status: '',
  };

  const [newMachine, setNewMachine] = useState(initialMachineState);

  useEffect(() => {
    fetchMachineList();
  }, []);

  const fetchMachineList = async () => {
    const token = getAuthToken();
    if (!token) return;

    setListLoading(true);
    try {
      const response = await axios.get(`${config.API}/machine/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data && Array.isArray(response.data.machines)) {
        setMachines(response.data.machines);
      } else {
        setMachines([]);
      }
    } catch (err) {
      console.error("Error fetching machines:", err.message);
    } finally {
      setListLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setNewMachine({ ...newMachine, [e.target.name]: e.target.value });
  };

  const handleAddClick = () => {
    setNewMachine(initialMachineState);
    setIsEditing(false);
    setEditingId(null);
    setShowModal(true);
  };

  const handleEdit = (row) => {
    const formattedLastMaintenance = row.last_maintenance_at ? new Date(row.last_maintenance_at).toISOString().split('T')[0] : '';
    const formattedNextMaintenance = row.next_maintenance_due ? new Date(row.next_maintenance_due).toISOString().split('T')[0] : '';

    setNewMachine({
      name: row.name || '',
      type: row.type || '',
      capacity: row.capacity || '',
      line: row.line || '',
      department: row.department || '',
      last_maintenance_at: formattedLastMaintenance,
      next_maintenance_due: formattedNextMaintenance,
      status: row.status || '',
    });
    setIsEditing(true);
    setEditingId(row.id);
    setShowModal(true);
  };

  const handleDelete = async (row) => {
    const token = getAuthToken();
    if (!token) return;

    if (window.confirm(`Are you sure you want to delete machine "${row.name}"?`)) {
      setListLoading(true);
      try {
        await axios.delete(`${config.API}/machine/${row.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        fetchMachineList();
      } catch (err) {
        console.error("Error deleting machine:", err.message);
      } finally {
        setListLoading(false);
      }
    }
  };

  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) return;

    if (!newMachine.name.trim() || !newMachine.type.trim() || !newMachine.status.trim()) {
      return;
    }

    const payload = {
      ...newMachine,
      name: newMachine.name.trim(),
      type: newMachine.type.trim(),
      capacity: newMachine.capacity.trim(),
      line: newMachine.line.trim(),
      department: newMachine.department.trim(),
      status: newMachine.status.trim(), 
      last_maintenance_at: newMachine.last_maintenance_at || null,
      next_maintenance_due: newMachine.next_maintenance_due || null,
    };

    setFormLoading(true);
    try {
      if (isEditing && editingId) {
        await axios.put(`${config.API}/machine/${editingId}`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
      } else {
        await axios.post(`${config.API}/machine/create`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
      }

      setShowModal(false);
      setIsEditing(false);
      setEditingId(null);
      setNewMachine(initialMachineState);
      fetchMachineList();
    } catch (err) {
      console.error("Error saving machine:", err.message);
    } finally {
      setFormLoading(false);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setIsEditing(false);
    setEditingId(null);
    setNewMachine(initialMachineState);
  };

  const filteredData = machines.filter(item =>
    Object.values(item || {})
      .join(' ')
      .toLowerCase()
      .includes(filterText.toLowerCase())
  );

  const columns = [
    { name: "ID", selector: row => row.id, sortable: true },
    { name: "Name", selector: row => row.name, sortable: true },
   // { name: "Type", selector: row => row.type, sortable: true },
    { name: "Capacity", selector: row => row.capacity, sortable: true },
    { name: "Line", selector: row => row.line, sortable: true },
    { name: "Department", selector: row => row.department, sortable: true },
   // {
    //  name: "Last Maintenance At",
    //  selector: row => row.last_maintenance_at ? new Date(row.last_maintenance_at).toLocaleDateString() : 'N/A',
    //  sortable: true
    //},
   // {
     // name: "Next Maintenance Due",
     // selector: row => row.next_maintenance_due ? new Date(row.next_maintenance_due).toLocaleDateString() : 'N/A',
     // sortable: true
    //},
    { name: "Status", selector: row => row.status, sortable: true },
    {
      name: "Actions",
      cell: row => (
        <div className="d-flex gap-1">
          <button className="btn btn-sm btn-primary m-2" onClick={() => handleEdit(row)} title="Edit Machine"><FaEdit /></button>
          <button className="btn btn-sm btn-danger m-2" onClick={() => handleDelete(row)} title="Delete Machine"><FaTrash /></button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];

  return (
    <div className="container-fluid mt-1">
      <div className="row justify-content-between align-items-center mb-3">
        <div className="row align-items-center">
          <div className="col-md-6">
            <strong className="mb-0 fs-4">Machine Details</strong>
          </div>
          <div className="col-md-6 d-flex justify-content-end gap-2">
            <input
              type="text"
              className="form-control"
              placeholder="Search..."
              value={filterText}
              onChange={e => setFilterText(e.target.value)}
              style={{ maxWidth: '250px' }}
            />
            <button className="btn btn-primary" onClick={handleAddClick}>
              + Add Machine
            </button>
          </div>
        </div>
      </div>

      {listLoading && <div className="text-center text-info py-3"><Loader /></div>}

      {!listLoading && (
        <DataTable
          columns={columns}
          data={filteredData}
          striped
          highlightOnHover
          dense
          pagination
          responsive
          persistTableHead
          customStyles={customStyles}
          noDataComponent={<div className="text-muted py-3">No machines found</div>}
        />
      )}

      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ background: "rgba(0,0,0,0.5)" }} aria-hidden="true">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-primary">
                <h5 className="modal-title text-light">
                  {isEditing ? "Edit Machine" : "Add Machine"}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={handleModalClose}
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="row g-3">
                  {/* Name */}
                  <div className="col-md-6">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={newMachine.name}
                      onChange={handleInputChange}
                      disabled={formLoading}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Type</label>
                    <Select
                      name="type"
                      value={
                        typeOptions.find((option) => option.value === newMachine.type) || null
                      }
                      onChange={(selectedOption) =>
                        handleInputChange({
                          target: {
                            name: "type",
                            value: selectedOption ? selectedOption.value : "",
                          },
                        })
                      }
                      options={typeOptions}
                      isDisabled={formLoading}
                      placeholder="Select type"
                      isSearchable
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Capacity</label>
                    <input
                      type="text"
                      className="form-control"
                      name="capacity"
                      value={newMachine.capacity}
                      onChange={handleInputChange}
                      disabled={formLoading}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Line</label>
                    <input
                      type="text"
                      className="form-control"
                      name="line"
                      value={newMachine.line}
                      onChange={handleInputChange}
                      disabled={formLoading}
                    />
                  </div>

                  {/* Department */}
                  <div className="col-md-6">
                    <label className="form-label">Department</label>
                    <input
                      type="text"
                      className="form-control"
                      name="department"
                      value={newMachine.department}
                      onChange={handleInputChange}
                      disabled={formLoading}
                    />
                  </div>

                  {/* Last Maintenance At */}
                  <div className="col-md-6">
                    <label className="form-label">Last Maintenance At</label>
                    <input
                      type="date"
                      className="form-control"
                      name="last_maintenance_at"
                      value={newMachine.last_maintenance_at}
                      onChange={handleInputChange}
                      disabled={formLoading}
                    />
                  </div>

                  {/* Next Maintenance Due */}
                  <div className="col-md-6">
                    <label className="form-label">Next Maintenance Due</label>
                    <input
                      type="date"
                      className="form-control"
                      name="next_maintenance_due"
                      value={newMachine.next_maintenance_due}
                      onChange={handleInputChange}
                      disabled={formLoading}
                    />
                  </div>

                  {/* Status */}
                  <div className="col-md-6">
                    <label className="form-label">Status</label>
                    <select
                      className="form-select"
                      name="status"
                      value={newMachine.status}
                      onChange={handleInputChange}
                      required
                      disabled={formLoading}
                    >
                      <option value="">Select</option>
                      <option value="Running">Running</option>
                     <option value="Idle">Idle</option>
                      <option value="Maintenance">Maintenance</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={handleModalClose} disabled={formLoading}>Cancel</button>
                <button className="btn btn-primary" onClick={handleSubmit} disabled={formLoading}>
                  {formLoading ? (isEditing ? 'Updating...' : 'Saving...') : (isEditing ? 'Update' : 'Save')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
